module.exports = __webpack_public_path__ + "static/media/kitty-love-3.dcc44ee5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/home-page/kitty-love-3.svg
// module id = 130
// module chunks = 0